import React from 'react';

const VARIANTS = {
  error: 'bg-danger-bg border-danger-line text-danger-ink',
  warning: 'bg-warning-bg border-warning-line text-warning-ink',
};

const ErrorAlert = ({ message, onDismiss, variant = 'error', icon }) => {
  if (!message) return null;
  return (
    <div className={`border px-4 py-3 rounded-lg text-sm flex items-start gap-2 ${VARIANTS[variant] || VARIANTS.error}`}>
      {icon && <span className="shrink-0 mt-0.5">{icon}</span>}
      <span className="flex-1 min-w-0">{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          aria-label="Dismiss"
          className="shrink-0 opacity-60 hover:opacity-100 leading-none text-lg"
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default ErrorAlert;
